import utils from '../../../../modules/utils';
import API from '../../../api/api';

function isTokenReceived(status) {
  return status === 'HOSTED_PAYMENT_TOKEN_RECEIVED';
}

function isReturningFromHostedPage() {
  return window.start.selectedPaymentMethod === 'ZIPPAY'
    || window.start.selectedPaymentMethod === 'QUADPAY'
    || window.start.selectedPaymentMethod === 'SPOTII';
}

function isProblemWithService(status) {
  return (status === 'HOSTED_PAYMENT_AUTHENTICATION_FAILED'
    || status === 'HOSTED_PAYMENT_CURRENTLY_UNAVAILABLE');
}

function returnedFromHostedPage(queryParams) {
  const {result} = utils.fn.getURIParams(queryParams);

  const sessionStatus = result === 'approved' ? 'SUCCESS' : 'FAILED';
  
  return API.doAPIRequest(`/v2/return-from-hosted/zippay?status=${sessionStatus}`);
}

export default {
  isTokenReceived, isProblemWithService, isReturningFromHostedPage, returnedFromHostedPage,
};
